<template>
  <div class="grid-view">
    <div
      class="main-content"
      type="primary"
    >
      <search-item
        config-module="410015202"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItems"
        no="1"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <el-button v-show="$checkPermission(['button_BillOverseasSCenter_accept'])" type="primary" no="2" @click="toSubmit()">{{ $t('CargoMsg.Cargo_Receive') }}</el-button>
          <el-button v-show="$checkPermission(['button_BillOverseasSCenter_billOverseasReturn'])" type="primary" no="3" @click="toReturn()">{{ $t('CargoMsg.Cargo_Return') }}</el-button>
          <el-button type="primary" no="4" @click="onPrint()">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="410015202"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="410015202"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-select-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :ctx="templateSelectorDialog.ctx"
    />
  </div>
</template>

<script>
import QueryBillOverseaCondition from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/query/queryBillOverseaCondition'
import { getLoading } from '@/utils/utilBaseElement'
import AmountSumMaster from '@/views/cargo/v0/Clearing/components/FinanceChargeSearch/AmountSumMaster'
import { queryBillOverseasAdv, batchUpdateStates } from '@/api/clearing/billingNative'
import StrUtils from '@/utils/StrUtils'
import BillOverseasSSubmitGrid from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/grid/billOverseasSSubmitGrid'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { getBankAccountList } from '@/api/bankAccount'
import { recordSelectedStatus } from '@/utils/agGrid'

export default {
  name: 'NewBillOverseasSSubmitView',
  components: { CargoTemplateSelectDialog, BillOverseasSSubmitGrid, AmountSumMaster, QueryBillOverseaCondition, searchItem },
  data() {
    return {
      gridParams: {},
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billingNo', colId: 'billingNo', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_CounterpartySBillingNo'), colId: 'counterPartyBillingNo', field: 'counterPartyBillingNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'), colId: 'jobNo', field: 'jobNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'), colId: 'jobOp', field: 'jobOp',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', colId: 'accountId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BillDate'), field: 'inputDate', colId: 'inputDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: 'MBL', field: 'jobMbl', colId: 'jobMbl', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_SettlementAgent'), field: 'settlementAgentId', colId: 'settlementAgentId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: 'ETD', field: 'jobEtd', colId: 'jobEtd', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ETA', field: 'jobEta', colId: 'jobEta', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ATD', field: 'jobAtd', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ATA', field: 'jobAta', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'jobBusinessDate', colId: 'jobBusinessDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'jobPono', colId: 'jobPono', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_CreditAmount'), field: 'amountCredit', colId: 'amountCredit', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'red' }
            }
            return {}
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DebitAmount'), field: 'amountDebit', colId: 'amountDebit', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'blue' }
            }
            return {}
          } },
        { headerName: this.$t('CargoMsg.Cargo_CreditNotWrittenOff'), field: 'amountCreditUnverify', colId: 'amountCreditUnverify', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'red' }
            }
            return {}
          } },
        { headerName: this.$t('CargoMsg.Cargo_DebitNotWrittenOff'), field: 'amountDebitUnverify', colId: 'amountDebitUnverify', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'blue' }
            }
            return {}
          } },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', colId: 'currency', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_BranchCMP'), field: 'branchId', colId: 'branchId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'), field: 'realClearingState', colId: 'realClearingState', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.clearingStateLabFun(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_BillStatus'), field: 'state', colId: 'state', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.getBillState(Number(params.value))
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessedBy'), colId: 'modifiedBy', field: 'modifiedBy',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessingTime'), colId: 'dateModified', field: 'dateModified',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', colId: 'remark', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_OurBank'),
          field: 'bankAccountChineseName',
          colId: 'bankAccountChineseName',
          width: 200
        }
      ],
      fullscreenLoading: null,
      isAdvancedQuery: false, // 是否为高级查询
      rowData: [],
      isBack: false,
      numAll: 100,
      numSelected: 0,
      sumCredit: '',
      sumDebit: '',
      selectedRows: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 100
      },
      filterJson: {},
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        category: 'BILLING',
        data: {},
        ctx: null,
        printedCallback: null
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: (event) => {
          this.selectedRows = event.api.getSelectedRows()
        }
      },
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true
    }
  },
  async created() {
    await this.initCustomSearchItems()
  },
  methods: {
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      const condition = AdvancedSearchOption.getOption('merge', this.filterJson.conditions)
      if (condition && condition.value && !AdvancedSearchOption.hasField('billing.ACCOUNTID', this.filterJson.conditions)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectBillingParty'))
        return
      }
      if (!AdvancedSearchOption.hasField('billing.STATE', this.filterJson.conditions)) {
        const option = new AdvancedSearchOption('FIELD_DROP_DOWN_LIST', 'billing.STATE', BillingConstants.BILLING_COMMITED.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        this.filterJson.conditions.push(option.formatObj2Json())
      }
      if (this.filterJson.conditions && this.filterJson.conditions.length > 0) {
        if (AdvancedSearchOption.hasField('billing.BRANCH_ID', this.filterJson.conditions)) {
          const option = AdvancedSearchOption.getOption('billing.BRANCH_ID', this.filterJson.conditions)
          this.filterJson.branchId = option.value
          AdvancedSearchOption.removeOption('billing.BRANCH_ID', this.filterJson.conditions)
        }
      }
      this.filterJson.isAdvancedQuery = true
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.fullscreenLoading = getLoading()
      queryBillOverseasAdv(this.filterJson).then(res => {
        this.handleQueryData(res)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    toSimpleQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.jobNo = data
        this.filter.pageNum = 1
      }
      this.filter.isAdvancedQuery = false
      this.filter.conditions = []
      if (!AdvancedSearchOption.hasField('billing.STATE', this.filter.conditions)) {
        const option = new AdvancedSearchOption('FIELD_DROP_DOWN_LIST', 'billing.STATE', BillingConstants.BILLING_COMMITED.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        this.filter.conditions.push(option.formatObj2Json())
      }
      this.filter.branchId = 0
      this.fullscreenLoading = getLoading()
      queryBillOverseasAdv(this.filter).then((res) => this.handleQueryData(res)).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      this.rowData = []
      for (const data of res.data.list) {
        if (data) {
          this.rowData.push(data)
        }
      }
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.loadingEnd()
      selectedStatus.revert()
    },
    bussDateLabFun(params) {
      const bill = params.data
      if (!bill || !bill.charge) { return '' }
      if (bill.charge.length > 0) {
        return ColumnUtils.dateLabelFunc(bill.charge[0].accountingDate)
      }
      return ''
    },
    loadingEnd() {
      this.isBack = false
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
      this.selectedRows = []
    },
    toReturn() {
      this.isBack = true
      this.updateState()
    },
    toSubmit() {
      this.isBack = false
      this.updateState()
    },
    // 退回,接受
    updateState() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      for (const billing of selectRows) {
        if (StrUtils.isEmpty(billing.billingNo)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlyBillsWithBillingNumbersCanBeSubmitted'))
          return
        }
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureDoThis'), this.$t('Pricing.Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(() => {
        if (this.checkSubmitBilling()) {
          // 退回到已打印状态
          this.fullscreenLoading = getLoading()
          batchUpdateStates(selectRows, { state: this.isBack ? 2 : 5 }).then(res => {
            this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
            this.gridOptions.api.updateRowData({ 'remove': selectRows })
            this.loadingEnd()
          }).catch(() => {
            this.fullscreenLoading.close()
          })
        }
      })
    },
    checkSubmitBilling() {
      for (const bill of this.selectedRows) {
        if (bill.state !== 4) {
          this.$message.warning(StrUtils.substitute(this.$t('CargoMsg.Cargo_BillWasNotSubmitted'), bill.billingNo))
          return false
        }
      }
      return true
    },
    // resetSearch() {
    //   this.$refs['queryBillOverseaCondition'].resetSearch()
    // },
    onPrint() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      const keyList = []
      for (const billing of selectRows) {
        keyList.push(billing.key)
      }
      const params = {
        BILLING_UUID_LIST: keyList,
        BILLING_UUID: keyList
      }
      // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
      if (selectRows.length === 1) {
        params['billingNo'] = selectRows[0].billingNo
        if (!StrUtils.isEmpty(selectRows[0].jobNo)) {
          params['jobNo'] = selectRows[0].jobNo
        }
      }
      this.templateSelectorDialog.visible = true
      this.templateSelectorDialog.ctx = null
      this.templateSelectorDialog.data = params
    },
    async initCustomSearchItems() {
      const defaultSearchFields = []
      // 银行名称和银行账号要去重
      const bankList = []
      const res = await getBankAccountList(this.$store.getters.currentOfficeUuid)
      if (res.data && res.data.length > 0) {
        for (const item of res.data) {
          bankList.push(item)
        }
      }
      // 我方银行名称
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'advanceSelect'
      searchField.multiple = 0
      searchField.action = 2
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemValue = []
      searchField.itemLabel = 'CargoMsg.Cargo_OurBank'
      searchField.itemName = 'billing.BANK_ACCOUNT_ID'
      searchField.headers = [this.$t('Clearing.BankName')]
      searchField.fields = ['bankChineseName']
      searchField.tagName = 'bankChineseName'
      searchField.tagValue = 'accountId'
      searchField.dataCacheKey = 'static_data_BankAccount'
      searchField.dataProvider = bankList
      defaultSearchFields.push(searchField.formatObj2Json())
      if (defaultSearchFields.length > 0) {
        this.customSearchItems.push(...defaultSearchFields)
        this.searchItemAutoInit = true
      }
    }
  }
}
</script>

<style lang="scss">
.bill-overseas-s-center-view{
  .totalLabel{
    margin-top: 6px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
